import { useState } from "react";
import { Facebook, Instagram, Twitter, Menu, X } from "react-feather";
import { Link } from "react-router-dom";
import styles from "./Corporatelandingtemplate.module.css";

const CorporateLandingTemplate = ({ data, isStickyHeader }) => {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const closeNav = () => setIsNavOpen(false);

    return (<div className={styles.page}>
        <header className={`${styles.header} ${isStickyHeader ? styles.headerSticky : styles.headerStatic}`}>
            <div className={styles.headerInner}>
                <div className={styles.logo}>
                    <img src={data && data?.logoURL ? data?.logoURL : "/images/logo.svg"} alt="logo" />
                </div>

                <nav className={`${styles.nav} ${isNavOpen ? styles.navOpen : ""}`}>
                    <button type="button" className={styles.menuToggle} aria-label="Close menu" onClick={closeNav} style={{ display: isNavOpen ? "inline-flex" : "none", alignSelf: "flex-end" }}>
                        <X size={26} />
                    </button>

                    <Link to={"/add-booking"} className={styles.navLink} onClick={closeNav}>Make A Booking</Link>
                    <Link to={"/contact-us"} className={styles.navLink} onClick={closeNav}>Contact Us</Link>
                    <Link to={"/sign-in"} className={styles.navLink} onClick={closeNav}>Sign In</Link>
                    <Link to={"/track-booking"} className={styles.navLink} onClick={closeNav}>Track</Link>

                    <button className={styles.phoneBtn}>{data && data?.phone ? data?.phone : ""}</button>
                </nav>

                <button type="button" className={styles.menuToggle} aria-label="Open menu" onClick={() => setIsNavOpen(true)}>
                    <Menu size={26} />
                </button>
            </div>
        </header>

        <section className={styles.hero} style={{ background: `linear-gradient(90deg, #001b4d 35%,rgba(0,27,77,0.6) 55%, transparent 100%), url(${data?.bannerImage ? data.bannerImage : "/images/template1-banner.jfif"})`, backgroundSize: "cover", backgroundPosition: "top center" }}>
            <div className={styles.heroInner}>
                <div className={styles.heroContent}>
                    <h1 className={styles.heroTitle}>{data && data?.heroTitle ? data?.heroTitle : ""}</h1>
                    <h3 className={styles.heroSubTitle}>{data && data?.heroSubTitle ? data?.heroSubTitle : ""}</h3>
                    <p className={styles.heroDescription}>{data && data?.heroDescription ? data?.heroDescription : ""}</p>
                </div>
            </div>
        </section>

        <section className={styles.servicesSection}>
            <div className={styles.sectionInner}>
                <h2 className={styles.servicesTitle}>{data && data?.serviceTitle ? data?.serviceTitle : ""}</h2>
                <div className={styles.servicesGrid}>
                    {(data?.services || []).map((item, index) => (<div key={index} className={styles.serviceCard}>
                        <div className={styles.serviceIcon}>
                            <img src={item?.icon} alt="icon" />
                        </div>
                        <h3 className={styles.serviceCardTitle}>{item.title}</h3>
                        <p className={styles.serviceCardDescription}>{item.description}</p>
                    </div>))}
                </div>
            </div>
        </section>

        <section className={styles.aboutSection}>
            <div className={styles.aboutGrid}>
                <div>
                    <img src={data && data?.aboutImage ? data?.aboutImage : "/images/template1-image.jfif"} alt="warehouse" className={styles.aboutImage} />
                </div>

                <div>
                    <h2 className={styles.aboutTitle}>{data && data?.aboutTitle ? data?.aboutTitle : ""}</h2>
                    <p className={styles.aboutDescription}>{data && data?.aboutDescription ? data?.aboutDescription : ""}</p>
                </div>
            </div>
        </section>

        <footer className={styles.footer}>
            <div className={styles.footerInner}>
                <div className={styles.footerTop}>
                    <div>
                        <h3 className={styles.footerHeading}>Contact Info</h3>
                        <p className={styles.footerText}>📞 {data && data?.phone ? data?.phone : ""}</p>
                        <p className={styles.footerText}>✉️ {data && data?.email ? data?.email : "admin@eflogistics.io"}</p>
                        <p className={styles.footerText}>📍 {data && data?.address ? data?.address : ""}</p>
                    </div>

                    <div>
                        <h3 className={styles.footerHeading}>Follow Us</h3>
                        <div className={styles.socialRow}>
                            <Link to={data && data?.facebookURL ? data?.facebookURL : "/"} target="_blank" className={styles.socialIcon}>
                                <Facebook />
                            </Link>
                            <Link to={data && data?.instagramURL ? data?.instagramURL : "/"} target="_blank" className={styles.socialIcon}>
                                <Instagram />
                            </Link>
                            <Link to={data && data?.twitterURL ? data?.twitterURL : "/"} target="_blank" className={styles.socialIcon}>
                                <Twitter />
                            </Link>
                        </div>
                    </div>
                </div>

                <div className={styles.copyright}>{data && data?.copyRightText ? data?.copyRightText : ""}</div>
            </div>
        </footer>
    </div>);
};

export default CorporateLandingTemplate;